"use strict";

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var common_1 = require("../../common");

var solver_1 = require("../../solver");

var Specification = require("../../specification");

var Graphics = require("../../graphics");

var common_2 = require("../common");

var ChartClass =
/*#__PURE__*/
function (_common_2$ObjectClass) {
  _inherits(ChartClass, _common_2$ObjectClass);

  function ChartClass() {
    _classCallCheck(this, ChartClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChartClass).apply(this, arguments));
  }

  _createClass(ChartClass, [{
    key: "setDataflow",
    value: function setDataflow(dataflow) {
      this.dataflow = dataflow;
    }
  }, {
    key: "setManager",
    value: function setManager(manager) {
      this.manager = manager;
    }
  }, {
    key: "getBackgroundGraphics",
    value: function getBackgroundGraphics() {
      return null;
    }
  }, {
    key: "resolveMapping",
    value: function resolveMapping(mapping, defaultValue) {
      if (mapping) {
        if (mapping.type == "value") {
          var value = mapping.value;
          return function () {
            return value;
          };
        }

        if (mapping.type == "scale") {
          var scaleMapping = mapping;
          var idx = common_1.indexOf(this.object.scales, function (x) {
            return x._id == scaleMapping.scale;
          });
          var scaleClass = common_2.ObjectClasses.Create(this.parent, this.object.scales[idx], this.state.scales[idx]);
          var expr = this.dataflow.cache.parse(scaleMapping.expression);
          return function (row) {
            return scaleClass.mapDataToAttribute(expr.getValue(row));
          };
        }
      }

      return function () {
        return defaultValue;
      };
    }
  }]);

  return ChartClass;
}(common_2.ObjectClass);

ChartClass.metadata = {
  iconPath: "chart",
  displayName: "Chart"
};
exports.ChartClass = ChartClass;

var RectangleChart =
/*#__PURE__*/
function (_ChartClass) {
  _inherits(RectangleChart, _ChartClass);

  function RectangleChart() {
    var _this;

    _classCallCheck(this, RectangleChart);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RectangleChart).apply(this, arguments)); // Get a list of elemnt attributes

    _this.attributeNames = ["x1", "y1", "x2", "y2", "cx", "cy", "ox1", "oy1", "ox2", "oy2", "width", "height", "marginLeft", "marginRight", "marginTop", "marginBottom"];
    _this.attributes = {
      x1: {
        name: "x1",
        type: Specification.AttributeType.Number
      },
      y1: {
        name: "y1",
        type: Specification.AttributeType.Number
      },
      x2: {
        name: "x2",
        type: Specification.AttributeType.Number
      },
      y2: {
        name: "y2",
        type: Specification.AttributeType.Number
      },
      cx: {
        name: "cx",
        type: Specification.AttributeType.Number
      },
      cy: {
        name: "cy",
        type: Specification.AttributeType.Number
      },
      ox1: {
        name: "ox1",
        type: Specification.AttributeType.Number
      },
      oy1: {
        name: "oy1",
        type: Specification.AttributeType.Number
      },
      ox2: {
        name: "ox2",
        type: Specification.AttributeType.Number
      },
      oy2: {
        name: "oy2",
        type: Specification.AttributeType.Number
      },
      width: {
        name: "width",
        type: Specification.AttributeType.Number,
        defaultValue: 900
      },
      height: {
        name: "height",
        type: Specification.AttributeType.Number,
        defaultValue: 600
      },
      marginLeft: {
        name: "marginLeft",
        type: Specification.AttributeType.Number,
        defaultValue: 50
      },
      marginRight: {
        name: "marginRight",
        type: Specification.AttributeType.Number,
        defaultValue: 50
      },
      marginTop: {
        name: "marginTop",
        type: Specification.AttributeType.Number,
        defaultValue: 50
      },
      marginBottom: {
        name: "marginBottom",
        type: Specification.AttributeType.Number,
        defaultValue: 50
      }
    };
    return _this;
  } // Initialize the state of a mark so that everything has a valid value


  _createClass(RectangleChart, [{
    key: "initializeState",
    value: function initializeState() {
      var attrs = this.state.attributes;
      attrs.width = 900;
      attrs.height = 600;
      attrs.marginLeft = 50;
      attrs.marginRight = 50;
      attrs.marginTop = 50;
      attrs.marginBottom = 50;
      attrs.cx = 0;
      attrs.cy = 0;
      attrs.x1 = -attrs.width / 2 + attrs.marginLeft;
      attrs.y1 = -attrs.height / 2 + attrs.marginBottom;
      attrs.x2 = +attrs.width / 2 - attrs.marginRight;
      attrs.y2 = +attrs.height / 2 - attrs.marginTop;
      attrs.ox1 = -attrs.width / 2;
      attrs.oy1 = -attrs.height / 2;
      attrs.ox2 = +attrs.width / 2;
      attrs.oy2 = +attrs.height / 2;
    }
  }, {
    key: "getBackgroundGraphics",
    value: function getBackgroundGraphics() {
      var attrs = this.state.attributes;

      if (this.object.properties.backgroundColor != null) {
        return Graphics.makeRect(-attrs.width / 2, -attrs.height / 2, attrs.width / 2, attrs.height / 2, {
          fillColor: this.object.properties.backgroundColor,
          fillOpacity: this.object.properties.backgroundOpacity
        });
      }
    } // Get intrinsic constraints between attributes (e.g., x2 - x1 = width for rectangles)

  }, {
    key: "buildIntrinsicConstraints",
    value: function buildIntrinsicConstraints(solver) {
      var attrs = this.state.attributes;

      var _solver$attrs = solver.attrs(attrs, ["x1", "y1", "x2", "y2", "ox1", "oy1", "ox2", "oy2", "cx", "cy", "width", "height", "marginLeft", "marginRight", "marginTop", "marginBottom"]),
          _solver$attrs2 = _slicedToArray(_solver$attrs, 16),
          x1 = _solver$attrs2[0],
          y1 = _solver$attrs2[1],
          x2 = _solver$attrs2[2],
          y2 = _solver$attrs2[3],
          ox1 = _solver$attrs2[4],
          oy1 = _solver$attrs2[5],
          ox2 = _solver$attrs2[6],
          oy2 = _solver$attrs2[7],
          cx = _solver$attrs2[8],
          cy = _solver$attrs2[9],
          width = _solver$attrs2[10],
          height = _solver$attrs2[11],
          marginLeft = _solver$attrs2[12],
          marginRight = _solver$attrs2[13],
          marginTop = _solver$attrs2[14],
          marginBottom = _solver$attrs2[15];

      solver.makeConstant(attrs, "width");
      solver.makeConstant(attrs, "height");
      solver.makeConstant(attrs, "marginLeft");
      solver.makeConstant(attrs, "marginRight");
      solver.makeConstant(attrs, "marginTop");
      solver.makeConstant(attrs, "marginBottom");
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, ox1]], [[-0.5, width]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, ox2]], [[+0.5, width]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, oy1]], [[-0.5, height]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, oy2]], [[+0.5, height]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, x1]], [[-0.5, width], [+1, marginLeft]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, x2]], [[+0.5, width], [-1, marginRight]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, y1]], [[-0.5, height], [+1, marginBottom]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, y2]], [[+0.5, height], [-1, marginTop]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[2, cx]], [[1, x1], [1, x2]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[2, cy]], [[1, y1], [1, y2]]);
    }
  }, {
    key: "getSnappingGuides",
    value: function getSnappingGuides() {
      var attrs = this.state.attributes;
      return [{
        type: "x",
        value: attrs.x1,
        attribute: "x1",
        visible: true
      }, {
        type: "x",
        value: attrs.x2,
        attribute: "x2",
        visible: true
      }, {
        type: "y",
        value: attrs.y1,
        attribute: "y1",
        visible: true
      }, {
        type: "y",
        value: attrs.y2,
        attribute: "y2",
        visible: true
      }, // <SnappingGuides.Axis>{ type: "x", value: attrs.ox1, attribute: "ox1", visible: true },
      // <SnappingGuides.Axis>{ type: "x", value: attrs.ox2, attribute: "ox2", visible: true },
      // <SnappingGuides.Axis>{ type: "y", value: attrs.oy1, attribute: "oy1", visible: true },
      // <SnappingGuides.Axis>{ type: "y", value: attrs.oy2, attribute: "oy2", visible: true },
      {
        type: "x",
        value: attrs.cx,
        attribute: "cx",
        visible: true
      }, {
        type: "y",
        value: attrs.cy,
        attribute: "cy",
        visible: true
      }];
    }
  }, {
    key: "getHandles",
    value: function getHandles() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      var inf = [-10000, 10000];
      return [{
        type: "relative-line",
        axis: "x",
        actions: [{
          type: "attribute-value-mapping",
          attribute: "marginLeft"
        }],
        reference: x1 - attrs.marginLeft,
        sign: 1,
        value: attrs.marginLeft,
        span: inf
      }, {
        type: "relative-line",
        axis: "x",
        actions: [{
          type: "attribute-value-mapping",
          attribute: "marginRight"
        }],
        reference: x2 + attrs.marginRight,
        sign: -1,
        value: attrs.marginRight,
        span: inf
      }, {
        type: "relative-line",
        axis: "y",
        actions: [{
          type: "attribute-value-mapping",
          attribute: "marginTop"
        }],
        reference: y2 + attrs.marginTop,
        sign: -1,
        value: attrs.marginTop,
        span: inf
      }, {
        type: "relative-line",
        axis: "y",
        actions: [{
          type: "attribute-value-mapping",
          attribute: "marginBottom"
        }],
        reference: y1 - attrs.marginBottom,
        sign: 1,
        value: attrs.marginBottom,
        span: inf // <Handles.RelativeLine>{
        //     type: "relative-line", axis: "x",
        //     value: attrs.width, sign: 1,
        //     reference: attrs.ox1,
        //     span: [attrs.oy1, attrs.oy2],
        //     actions: [
        //         { type: "attribute-value-mapping", attribute: "width", minimum: 50 }
        //     ]
        // },
        // <Handles.RelativeLine>{
        //     type: "relative-line", axis: "x",
        //     value: attrs.width, sign: -1,
        //     reference: attrs.ox2,
        //     span: [attrs.oy1, attrs.oy2],
        //     actions: [
        //         { type: "attribute-value-mapping", attribute: "width", minimum: 50 }
        //     ]
        // },
        // <Handles.RelativeLine>{
        //     type: "relative-line", axis: "y",
        //     value: attrs.height, sign: 1,
        //     reference: attrs.oy1,
        //     span: [attrs.ox1, attrs.ox2],
        //     actions: [
        //         { type: "attribute-value-mapping", attribute: "height", minimum: 50 }
        //     ]
        // },
        // <Handles.RelativeLine>{
        //     type: "relative-line", axis: "y",
        //     value: attrs.height, sign: -1,
        //     reference: attrs.oy2,
        //     span: [attrs.ox1, attrs.ox2],
        //     actions: [
        //         { type: "attribute-value-mapping", attribute: "height", minimum: 50 }
        //     ]
        // }

      }];
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      var result = [manager.sectionHeader("Dimensions"), manager.mappingEditor("Width", "width", {}), manager.mappingEditor("Height", "height", {}), manager.sectionHeader("Margins"), manager.mappingEditor("Left", "marginLeft", {}), manager.mappingEditor("Right", "marginRight", {}), manager.mappingEditor("Top", "marginTop", {}), manager.mappingEditor("Bottom", "marginBottom", {}), manager.sectionHeader("Background"), manager.row("Color", manager.inputColor({
        property: "backgroundColor"
      }, {
        allowNull: true
      }))];

      if (this.object.properties.backgroundColor != null) {
        result.push(manager.row("Opacity", manager.inputNumber({
          property: "backgroundOpacity"
        }, {
          showSlider: true,
          sliderRange: [0, 1]
        })));
      }

      return result;
    }
  }, {
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      if (this.object.mappings.text && this.object.mappings.text.type == "scale") {
        return null;
      } else {
        return {
          properties: [{
            objectID: this.object._id,
            target: {
              attribute: "marginLeft"
            },
            type: Specification.AttributeType.Number,
            default: this.state.attributes.marginLeft
          }, {
            objectID: this.object._id,
            target: {
              attribute: "marginRight"
            },
            type: Specification.AttributeType.Number,
            default: this.state.attributes.marginRight
          }, {
            objectID: this.object._id,
            target: {
              attribute: "marginTop"
            },
            type: Specification.AttributeType.Number,
            default: this.state.attributes.marginTop
          }, {
            objectID: this.object._id,
            target: {
              attribute: "marginBottom"
            },
            type: Specification.AttributeType.Number,
            default: this.state.attributes.marginBottom
          }]
        };
      }
    }
  }]);

  return RectangleChart;
}(ChartClass);

RectangleChart.classID = "chart.rectangle";
RectangleChart.type = "chart";
RectangleChart.defaultMappingValues = {
  width: 900,
  height: 600,
  marginLeft: 50,
  marginRight: 50,
  marginTop: 50,
  marginBottom: 50,
  cx: 0,
  cy: 0
};
RectangleChart.defaultProperties = {
  backgroundColor: null,
  backgroundOpacity: 1
};

function registerClasses() {
  common_2.ObjectClasses.Register(RectangleChart);
}

exports.registerClasses = registerClasses;